import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { Nullable } from '@/shared/types/app.types'
import { SubportionStateMachineConfigurationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/subportion-state-machines/services/configuration-subportion-state-machines/configuration-subportion-state-machines.dto'
import { subportionStateMachineConfigurationService } from '@/modules/configurationModule/detail/local-laboratory-module/subportion-state-machines/services/configuration-subportion-state-machines/configuration-subportion-state-machines.service'
import { store } from '@/store/store'

export const columnsDefLocalAssaysAssaygroupsLaboratoryGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.section'),
            field: 'section.name',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.subportionType'),
            field: 'subportionType.sptName',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.filePath'),
            field: 'filePath',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export interface SubportionStateMachinesGridState extends CrudModelPaginatorLaboratory<SubportionStateMachineConfigurationResponse> {
    service: typeof subportionStateMachineConfigurationService
    laboratoryId: number
    sectionId: Nullable<number>
}
export const initialSubportionStateMachinesGridState =
    (): SubportionStateMachinesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.laboratoryModule.subportionStateMachines',
        columnsDef: columnsDefLocalAssaysAssaygroupsLaboratoryGrid(),
        datasource: new PaginatorLaboratoryDatasource(subportionStateMachineConfigurationService, store.getters.labId),
        service: subportionStateMachineConfigurationService,
        laboratoryId: store.getters.labId,
        sectionId: null
    })
